import script from "./deleteLineRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./deleteLineRegistration.vue?vue&type=script&setup=true&lang=js"

import "./deleteLineRegistration.vue?vue&type=style&index=0&id=1ec23449&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec23449"]])

export default __exports__